import { managerGridHeight } from '~/utils';

const styles = {
  container: {
    display: 'flex',
    backgroundColor: '#F9F9F9',
    height: managerGridHeight,
    padding: 10,
  },
  icon: {
    marginRight: 10,
  },
  button: {
    color: '#FFF',
    margin: 5,
  },
  tabContainer: {
    borderRadius: 5,
    borderTopLeftRadius: 0,
    backgroundColor: 'white',
    padding: 10,
  },
  tabContent: {
    height: 'clamp(260px, 55vh, 720px)',
    flex: '1 1 auto',
    overflow: 'auto',
  },
  tabContentProjectStatusTab: {
    height: 'clamp(260px, 50vh, 720px)',
    flex: '1 1 auto',
    overflow: 'auto',
  },
  tabFooter: {
    flex: '0 0 auto',
    paddingTop: 10,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 12,
  },
  field: {
    border: '1px solid #CDCDCD',
    borderRadius: 5,
    height: 40,
  },
  fieldError: {
    border: '1px solid red !important',
    borderRadius: 5,
    height: 40,
  },
  classGroupName: {
    flex: 1,
    minWidth: 290,
    marginLeft: 32,
    marginRight: 32,
  },
  formLabel: {
    color: '#647886',
    fontSize: 12,
    fontFamily: 'Roboto',
    marginBottom: 5,
  },
  errorMessage: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    textAlign: 'center',
    color: '#EC3337',
  },
  containerTypeSelector: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'center',
    width: '100%',
    padding: '10px 0px',
  },
  labelTypeSelector: {
    color: '#647886',
    fontFamily: 'Barlow Condensed',
    fontWeight: 600,
    fontSize: 18,
    textTransform: 'uppercase',
    marginRight: 10,
  },
  typeSelector: {
    height: 40,
    fontFamily: 'Roboto',
    fontWeight: 300,
    fontSize: 14,
    color: '#CDCDCD',
  },
  scrollbars: {
    border: '1px solid #CDCDCD',
    borderRadius: 4,
    boxSizing: 'border-box',
    minHeight: 260,
    height: 'auto',
  },
  label: {
    color: '#647886',
    fontSize: 12,
    fontFamily: 'Roboto',
    marginBottom: 5,
  },
};

export default styles;
